(function(Spider) {
    'use strict';

    var $spider = $('.js-spider');
    var $items = $spider.find('.js-spider-item');

    var $title = $('.js-spider-title');
    var $body = $('.js-spider-body');
    var $button = $('.js-spider-button');
    var index = 0;
    var $item;
    var timeOut;

    Spider.loop = function(i) {
        $item = $items.eq(i);
        $items.removeClass('is-active');
        $item.addClass('is-active');

        $title.html($item.data('title'));
        $body.html($item.data('body'));

        if ($item.data('buttontext') && $item.data('buttonlink')) {
            $button.html($item.data('buttontext'));
            $button.attr('href', $item.data('buttonlink'));
            $button.show();
        } else {
            $button.hide();
        }

        timeOut = setTimeout(function() {
            index = (i + 1) % $items.length;
            Spider.loop(index);
        }, 3000);
    };

    Spider.bindEvents = function() {

        $items.on('mouseenter', function() {
            window.clearTimeout(timeOut);

            $items.removeClass('is-active');
            $(this).addClass('is-active');

            $title.html($(this).data('title'));
            $body.html($(this).data('body'));

            if ($(this).data('buttontext') && $(this).data('buttonlink')) {
                $button.html($(this).data('buttontext'));
                $button.attr('href', $(this).data('buttonlink'));
                $button.show();
            } else {
                $button.hide();
            }

            index = $(this).index();
        }).on('mouseleave', function() {
            $items.removeClass('is-active');
            Spider.loop(index);
        });

    };

    Spider.init = function() {
        Spider.loop(index);
        Spider.bindEvents();
    };

})(window.Way2web.Spider = window.Way2web.Spider || {});
